/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_DescriptionInputs */

const en_guide_large_json_files_description = /** @type {(inputs: Guide_Large_Json_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn strategies for handling large JSON files efficiently. Tips for performance, memory management, and practical tools.`)
};

const ko_guide_large_json_files_description = /** @type {(inputs: Guide_Large_Json_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일을 효율적으로 처리하는 전략을 알아보세요. 성능, 메모리 관리, 실용적인 도구에 대한 팁을 제공합니다.`)
};

const ja_guide_large_json_files_description = /** @type {(inputs: Guide_Large_Json_Files_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルを効率的に処理する戦略を学びましょう。パフォーマンス、メモリ管理、実用的なツールに関するヒント。`)
};

/**
* | output |
* | --- |
* | "Learn strategies for handling large JSON files efficiently. Tips for performance, memory management, and practical tools." |
*
* @param {Guide_Large_Json_Files_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_description = /** @type {((inputs?: Guide_Large_Json_Files_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_description(inputs)
	if (locale === "ko") return ko_guide_large_json_files_description(inputs)
	return ja_guide_large_json_files_description(inputs)
});